const getOrderDeliveryNotes = ({ orderNotes, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }

  if (orderNotes) {
    return orderNotes
      .filter(item => item['Notes Category'].filter(category => category['Is Delivery']).length > 0)
      .map(item => `${item.Text};`)
      .join('\n');
  }
  return '';
};

export default getOrderDeliveryNotes;



// WEBPACK FOOTER //
// ./src/utils/print/getOrderDeliveryNotes.js